/* Glisser à la souris dans les carrousels de produits (bureau). Code écrit pour ce thème.
   Même réglage que lancaster.com : le déplacement de la souris est doublé (x2), le curseur devient « grabbing »,
   un clic qui suit un glissement n'ouvre pas la fiche produit.
   Pendant le glissement, l'accroche (scroll-snap) et le défilement doux sont coupés pour que le mouvement soit
   fluide ; ils reviennent au relâchement. Les carrousels ajoutés plus tard (recommandations, vu récemment)
   sont repris automatiquement. Événements lcdragstart / lcdragend envoyés sur la liste. */
(function () {
  if (window.__lcDragScroll) return;
  window.__lcDragScroll = true;

  var SELECTOR = '.slider-scroll, .lc-hs .featured-collection-w-image .slider, .lc-reco__list, .recently-viewed-products .product-grid';
  var MULTIPLIER = 2;
  var THRESHOLD = 5;

  function bind(list) {
    if (list.__lcDrag) return;
    list.__lcDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;

    list.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || list.scrollWidth <= list.clientWidth) return;
      e.preventDefault();
      down = true; moved = false; startX = e.pageX; startLeft = list.scrollLeft;
      list.classList.add('active');
      list.style.scrollSnapType = 'none';
      list.style.scrollBehavior = 'auto';
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var d = (e.pageX - startX) * MULTIPLIER;
      if (!moved && Math.abs(d) > THRESHOLD) { moved = true; list.dispatchEvent(new CustomEvent('lcdragstart')); }
      if (moved) { e.preventDefault(); list.scrollLeft = startLeft - d; }
    });
    function end() {
      if (!down) return;
      down = false;
      list.classList.remove('active');
      list.style.scrollSnapType = '';
      list.style.scrollBehavior = '';
      if (moved) list.dispatchEvent(new CustomEvent('lcdragend'));
    }
    window.addEventListener('mouseup', end);
    document.addEventListener('mouseleave', end);
    list.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(SELECTOR)) bind(root);
    root.querySelectorAll(SELECTOR).forEach(bind);
  }

  var queued = false;
  function init() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
